import styled, { css } from "styled-components";
import type { ConnectorLogoSize } from "./ConnectorLogo.types";

const SIZE_PX: Record<ConnectorLogoSize, number> = {
  kg: 12,
  xxs: 16,
  xs: 20,
  sm: 24,
  md: 40,
  lg: 56,
};

export const LogoFrame = styled.span<{
  $size: ConnectorLogoSize;
  $darkBackdrop?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: ${({ $size }) => SIZE_PX[$size]}px;
  height: ${({ $size }) => SIZE_PX[$size]}px;
  overflow: hidden;
  box-sizing: border-box;
  ${({ $darkBackdrop, theme }) =>
    $darkBackdrop && theme?.mode === "dark"
      ? css`
          padding: 8%;
          border-radius: 20%;
          background: ${theme.colors.background.inverse};
        `
      : ""}
`;

export const LogoImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
`;
